import React from 'react';
import * as S from './DetailsRightBlock.styles';

import MyTripActions from '../../../common/MyTripActions/MyTripActions';
import PriceBreakUp from './PriceBreakUp/PriceBreakUp';

const DetailsRightBlock = ({actionLinks, paymentDetails}) => {
  const {fare_breakup = [], payment_breakup = []} = paymentDetails;
  return (
    <S.RightBlockMainWrap>
      <MyTripActions actionLinks={actionLinks} />
      <PriceBreakUp title="Pricing Breakup" breakup={fare_breakup} />
      <PriceBreakUp title="Payment Breakup" breakup={payment_breakup} />
    </S.RightBlockMainWrap>
  )
}

export default DetailsRightBlock;